import { c as create_ssr_component, a as subscribe, e as escape, b as add_attribute } from "../../chunks/ssr.js";
import { _ as ___ASSET___0 } from "../../chunks/four_planes.js";
import { p as page } from "../../chunks/stores.js";
const _error_svelte_svelte_type_style_lang = "";
const css = {
  code: ".wrapper.svelte-b4er1z{height:100%;width:100%;display:grid;place-items:center;padding-block:10rem;padding-inline:5rem}h1.svelte-b4er1z{color:#f36d21;font-size:2.8rem}.img.svelte-b4er1z{pointer-events:none;max-width:90%;height:auto;transform:rotate(-25deg)}",
  map: null
};
const Error = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$result.css.add(css);
  $$unsubscribe_page();
  return `<div class="wrapper svelte-b4er1z"> <h1 class="svelte-b4er1z">${escape($page.status)} ${escape($page.error?.message)}</h1> <div data-svelte-h="svelte-yzpcnk"><img class="img svelte-b4er1z" alt=""${add_attribute("src", ___ASSET___0, 0)}></div>  </div>`;
});
export {
  Error as default
};
